// extracted by mini-css-extract-plugin
module.exports = {"container":"Post_container__2V1es"};